module.exports = __webpack_public_path__ + "img/base_divers_divers.884a6f11.svg";